/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Models_EyebrowInputs */

const en_directory_models_eyebrow = /** @type {(inputs: Directory_Models_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Model directory`)
};

const zh_directory_models_eyebrow = /** @type {(inputs: Directory_Models_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`模型目录`)
};

/**
* | output |
* | --- |
* | "Model directory" |
*
* @param {Directory_Models_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_models_eyebrow = /** @type {((inputs?: Directory_Models_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Models_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_models_eyebrow(inputs)
	return zh_directory_models_eyebrow(inputs)
});
export { directory_models_eyebrow as "directory.models.eyebrow" }